import {CustomViewTab} from "@/utils/tabs/custom-view-tab";

export class CustomViewTabWrapper {
	Browse1: CustomViewTab[] = [];
	Browse2: CustomViewTab[] = [];
	Browse3: CustomViewTab[] = [];
	Browse4: CustomViewTab[] = [];
	Browse5: CustomViewTab[] = [];
	Browse6: CustomViewTab[] = [];
	Browse7: CustomViewTab[] = [];
	Browse8: CustomViewTab[] = [];
	Browse9: CustomViewTab[] = [];
	Browse10: CustomViewTab[] = [];
	Browse11: CustomViewTab[] = [];
	Browse12: CustomViewTab[] = [];
	Browse23: CustomViewTab[] = [];

	public constructor(data?:any){
		if (!data || !data.Browse1) return;

		this.Browse1 = data["Browse1"]?.map((c:CustomViewTab)=>new CustomViewTab(c)) || [];
		this.Browse2 = data["Browse2"]?.map((c:CustomViewTab)=>new CustomViewTab(c)) || [];
		this.Browse3 = data["Browse3"]?.map((c:CustomViewTab)=>new CustomViewTab(c)) || [];
		this.Browse4 = data["Browse4"]?.map((c:CustomViewTab)=>new CustomViewTab(c)) || [];
		this.Browse5 = data["Browse5"]?.map((c:CustomViewTab)=>new CustomViewTab(c)) || [];
		this.Browse6 = data["Browse6"]?.map((c:CustomViewTab)=>new CustomViewTab(c)) || [];
		this.Browse7 = data["Browse7"]?.map((c:CustomViewTab)=>new CustomViewTab(c)) || [];
		this.Browse8 = data["Browse8"]?.map((c:CustomViewTab)=>new CustomViewTab(c)) || [];
		this.Browse9 = data["Browse9"]?.map((c:CustomViewTab)=>new CustomViewTab(c)) || [];
		this.Browse10 = data["Browse10"]?.map((c:CustomViewTab)=>new CustomViewTab(c)) || [];
		this.Browse11 = data["Browse11"]?.map((c:CustomViewTab)=>new CustomViewTab(c)) || [];
		this.Browse12 = data["Browse12"]?.map((c:CustomViewTab)=>new CustomViewTab(c)) || [];
		this.Browse23 = data["Browse23"]?.map((c:CustomViewTab)=>new CustomViewTab(c)) || [];
	}

	public getJSON(){
		return {
			Browse1: this.Browse1,
			Browse2: this.Browse2,
			Browse3: this.Browse3,
			Browse4: this.Browse4,
			Browse5: this.Browse5,
			Browse6: this.Browse6,
			Browse7: this.Browse7,
			Browse8: this.Browse8,
			Browse9: this.Browse9,
			Browse10: this.Browse10,
			Browse11: this.Browse11,
			Browse12: this.Browse12,
			Browse23: this.Browse23
		};
	}

	public getTabNamesForBrowse(browseId:number): any{
		if(!(this as any)["Browse" + browseId]) return [];
		let t = (this as any)["Browse" + browseId].map((c: CustomViewTab) => c.Name);
		return t;
	}

}